import { render, staticRenderFns } from "./PostRender.vue?vue&type=template&id=c9a5f650&scoped=true&"
import script from "./PostRender.vue?vue&type=script&lang=js&"
export * from "./PostRender.vue?vue&type=script&lang=js&"
import style0 from "./PostRender.vue?vue&type=style&index=0&id=c9a5f650&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a5f650",
  null
  
)

export default component.exports